/** @format */

import { ServerConstants } from '../interfaces/server-constants.interface';

/**
 * @description
 * Server constants to be used by Express for serving @angular applications via
 * our custom Express Application
 *
 * NOTE: Regarding VirtualHost identifiers...the values are mapped as follows:
 * 111 = www.dickssportinggoods.com
 * 112 = aos.dickssportinggoods.com
 * 121 = www.golfgalaxy.com
 * 122,125 = aos.golfgalaxy.com
 * 161 = www.publiclands.com
 * 162 = aos.publiclands.com
 * 163 = www.publiclandsfund.org
 * 171 = www.goinggoing.com
 * 172 = aos.goinggoing.com
 * 500 = www.sportsmatter.org
 * 181 = Moosejaw
 */
export const SERVER_CONSTANTS: ServerConstants = {
  botExclusions: ['chrome-lighthouse', 'pagespeed'],
  botInclusions: ['aka-bot'],
  react: {
    header: {
      virtualHostIdentifiers: {
        default: ['111', '112', '121', '122', '125', '131'],
        microSite: ['161', '162', '163', '171', '172', '500', '181', '182'],
      },
    },
    footer: {
      virtualHostIdentifiers: {
        default: ['111', '112', '121', '122', '125', '131'],
        microSite: ['161', '162', '163', '171', '172', '500', '181', '182'],
      },
    },
  },
  virtualHostIdentifiers: {
    eComm: ['111', '121', '131', '161', '171', '181'],
    kiosk: ['112', '122', '125', '162', '172', '182'],
    nonProfit: ['163', '500'],
  },
};
